"use client";

import { c as _c } from "react/compiler-runtime";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { tv } from "tailwind-variants";
import { classNames } from "../../utils";
const progressVariants = tv({
  variants: {
    interactive: {
      true: "hover:bg-bg-additional-2"
    },
    variant: {
      default: "bg-bg-additional-1",
      green: "bg-transparent",
      success: "bg-bg-additional-1",
      blue: "bg-bg-additional-1",
      rounded: "bg-bg-additional-1"
    },
    rounded: {
      true: "rounded-full",
      false: "rounded"
    }
  },
  defaultVariants: {
    rounded: false
  }
});
const indicatorVariants = tv({
  variants: {
    variant: {
      default: "bg-gradient-to-r from-blue-1 to-blue-3",
      green: "bg-success-1-transparent-2",
      success: "bg-success-1",
      blue: "bg-blue-2"
    },
    rounded: {
      true: "rounded-full",
      false: "rounded"
    }
  },
  defaultVariants: {
    rounded: false
  }
});
/**
 * Displays an indicator showing the completion progress of a task, typically displayed as a progress bar.
 */
export function Progress(t0) {
  const $ = _c(26);
  let children;
  let className;
  let interactive;
  let props;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      className,
      interactive,
      variant: t1,
      rounded: t2,
      value,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = interactive;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
    $[7] = value;
  } else {
    children = $[1];
    className = $[2];
    interactive = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
    value = $[7];
  }
  const variant = t1 === undefined ? "default" : t1;
  const rounded = t2 === undefined ? false : t2;
  let t3;
  if ($[8] !== className || $[9] !== interactive || $[10] !== rounded || $[11] !== variant) {
    t3 = classNames("relative size-full overflow-hidden", progressVariants({
      interactive,
      variant,
      rounded
    }), className);
    $[8] = className;
    $[9] = interactive;
    $[10] = rounded;
    $[11] = variant;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== rounded || $[14] !== variant) {
    t4 = classNames("size-full flex-1 transition", indicatorVariants({
      variant,
      rounded
    }));
    $[13] = rounded;
    $[14] = variant;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const t5 = `${value ?? 0}%`;
  let t6;
  if ($[16] !== t5) {
    t6 = {
      width: t5
    };
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== children || $[19] !== t4 || $[20] !== t6) {
    t7 = <ProgressPrimitive.Indicator className={t4} style={t6}>{children}</ProgressPrimitive.Indicator>;
    $[18] = children;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== props || $[23] !== t3 || $[24] !== t7) {
    t8 = <ProgressPrimitive.Root className={t3} {...props}>{t7}</ProgressPrimitive.Root>;
    $[22] = props;
    $[23] = t3;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}